import axios from 'axios'
import {useEffect, useState} from 'react'
import './style.scss'

export const AutoUpdate = props => {
  const [hasUpdate, setHasUpdate] = useState(false)
  const [tracker, setTracker] = useState({})

  const onUpdate = () => {
    window.localStorage.setItem(tracker.key, tracker.value)
    window.location.reload(true)
  }

  const checkForUpdate = async () => {
    console.log(`Checking for update`)
    const manifest = await axios.get('/asset-manifest.json')
    const key = process.env.REACT_APP_VERSION_KEY
    const main = window.localStorage.getItem(key)

    if (!main) {
      window.localStorage.setItem(
        process.env.REACT_APP_VERSION_KEY,
        manifest.data.files['main.js']
      )
      return
    }

    if (main !== manifest.data.files['main.js']) {
      setTracker({
        value: manifest.data.files['main.js'],
        key
      })
      setHasUpdate(true)
    }
  }

  useEffect(() => {
    const interval = setInterval(checkForUpdate, 20000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return hasUpdate ? (
    <div className="bg-primary text-center fw-bold text-light auto-update p-2">
      App Update Available, Refresh the app now to use latest app
      <button className="btn btn-sm btn-primary ml-2" onClick={onUpdate}>
        Reload
      </button>
    </div>
  ) : null
}
